module.exports = "https://r.nearpod.com/assets/media/image/clever-icon-acb1f8012449d05309f998b2cde2d779.svg";